import { IPersonParams, IUserDetailRequest, IUserParams } from 'core/model/interfaces/users';
import { usersData } from './users.data';
import {
  mapPersonDetailsDtoToDomain,
  mapPersonParamsDomainToDto,
  mapUserDetailsDomainToDto,
  mapUserDetailsDtoToDomain,
  mapUserListDtoToDomain,
  mapUserParamsDomainToDto,
} from './users.mapper';

export const usersService = {
  getUserList: async (params: IUserParams) => {
    const response = await usersData.getUserList(mapUserParamsDomainToDto(params));
    return mapUserListDtoToDomain(response);
  },
  getUserDetail: async (id: number) => {
    const response = await usersData.getUserDetail(id);
    return mapUserDetailsDtoToDomain(response);
  },
  updateUser: async (body: IUserDetailRequest) => {
    await usersData.updateUser(mapUserDetailsDomainToDto(body));
  },
  getUser: async (params: IPersonParams) => {
    const response = await usersData.getUser(mapPersonParamsDomainToDto(params));
    return mapPersonDetailsDtoToDomain(response);
  },
  activateUser: async (body: IUserDetailRequest) => {
    await usersData.activateUser(mapUserDetailsDomainToDto(body));
  },
  resetPassword: async (id: number) => {
    await usersData.resetPassword(id);
  },
};
